export default "__VITE_ASSET__fN2QfvUo__"